import { render, staticRenderFns } from "./conInfo.vue?vue&type=template&id=2e2ab65f"
import script from "./conInfo.vue?vue&type=script&lang=js"
export * from "./conInfo.vue?vue&type=script&lang=js"
import style0 from "./conInfo.vue?vue&type=style&index=0&id=2e2ab65f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports